import { APICallProps } from '@types';
import { isMultiRatePayload, toMultiRateStorePayload } from '@utils/multiRatePricing';
import { useFeatureFlag } from './useFeatureFlag';

/** Sends a PER_ITEM payload to the given v2 endpoint when ugly_freight_types_v2 is on; else untouched. */
export const useMultiRateRoute = () => {
	const multiRateActive = useFeatureFlag('ugly_freight_types_v2') as boolean;
	return (v2Url: string, props?: APICallProps): APICallProps | undefined => {
		if (!multiRateActive || !props || !isMultiRatePayload(props.payload)) return props;
		return { ...props, overrideUrl: v2Url };
	};
};

/** Sends a PER_ITEM payload to the v1 store as `is_multi_rate` when ugly_freight_types_v2 is on; else untouched. */
export const useMultiRateStore = () => {
	const multiRateActive = useFeatureFlag('ugly_freight_types_v2') as boolean;
	return (props?: APICallProps): APICallProps | undefined => {
		if (!multiRateActive || !props || !isMultiRatePayload(props.payload)) return props;
		return { ...props, payload: toMultiRateStorePayload(props.payload) };
	};
};
